import { trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { maxHeightIf } from '../../../animations/max-height.if.animation';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-gallery-settings-customize-button',
  imports: [ButtonDirective, SvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('button', maxHeightIf(14))],
  templateUrl: './gallery-settings-customize-button.component.html',
  styleUrl: './gallery-settings-customize-button.component.scss',
})
export class GallerySettingsCustomizeButtonComponent {
  location = input.required<string>();
  show = input.required<boolean>();
  onClick = output<void>();
}
